import { Component } from "@angular/core";

@Component({
  selector: "quoter-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {}
